'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _MultiFormComponent = require('../../components/common/MultiFormComponent');

var _MultiFormComponent2 = _interopRequireDefault(_MultiFormComponent);

var _ActionCreators = require('../../actions/ActionCreators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    navigation: state.navigation
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setNumPages: function setNumPages(numPages) {
      dispatch((0, _ActionCreators.setNumPages)({
        numPages: numPages
      }));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_MultiFormComponent2.default);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/common/MultiFormContainer.jsx
// module id = 20
// module chunks = 0